import { resolveLanguageFromPath } from '../codeEditor/languageCapabilityRegistry';

/**
 * Monaco editor language id for a file path or extension (with or without leading dot).
 * Filename-aware for Dockerfile, Makefile, .gitignore, .editorconfig, .npmrc, etc.
 */
export function languageFromPath(pathOrExtension: string): string {
  return resolveLanguageFromPath(pathOrExtension);
}
